import { UpperCasePipe } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CmsUrlPipe, NavHeaderRepository } from '@usana/ux/cms';
import { AppLinkDirective } from '../../modules/common/app-link.directive';
import { UserService } from '../../modules/common/user.service';
import { CmsTypeGuard } from '../cms-type.guard';
import { DotcomTranslateService } from '../dotcom-translate/dotcom-translate.service';
import { DotcomNavBase } from './dotcom-nav-base';
import { ShopNavFullMenuComponent } from './shop-nav-full-menu.component';

export type { CmsNavData, DotcomMenuItem } from './dotcom-nav.models';

/**
 * Renders dotcom navigation menu items in the cart-ux header bottom bar.
 * Only mounted when the current route is under /ux/dotcom (parent controls
 * visibility via *ngIf="isDotcomRoute" in main-header.component.html).
 *
 * For CMS markets (e.g. en-US, es-US, zh-US): fetches structured nav_header
 * content from Contentstack via NavHeaderRepository, rendering a mega-menu
 * with column sub-headers per NavHeaderBlock.columns[].columnTitle.
 *
 * For non-CMS markets: mirrors the logic of dotcom's MenuDesktopComponent,
 * loading up to 6 items from `menu.N.{url,name,target}` translation keys
 * via the usanadotcom namespace.
 */
@Component({
    selector: 'dotcom-nav-menu',
    templateUrl: './dotcom-nav-menu.component.html',
    styleUrls: ['./dotcom-nav-menu.component.scss'],
    standalone: true,
    imports: [UpperCasePipe, CmsUrlPipe, AppLinkDirective, ShopNavFullMenuComponent],
})
export class DotcomNavMenuComponent extends DotcomNavBase {

    /** Index of the currently open dropdown (null = all closed; -1 = Shop sub-nav). */
    cmsOpenIndex: number | null = null;

    constructor(
        dotcomTranslateService: DotcomTranslateService,
        userService: UserService,
        cmsTypeGuard: CmsTypeGuard,
        router: Router,
        navHeaderRepository: NavHeaderRepository,
    ) {
        super(dotcomTranslateService, userService, cmsTypeGuard, router, navHeaderRepository);
    }

    @HostListener('document:click')
    closeAllDropdowns(): void {
        this.cmsOpenIndex = null;
    }

    toggleCmsSection(event: Event, index: number): void {
        event.stopPropagation();
        this.cmsOpenIndex = this.cmsOpenIndex === index ? null : index;
    }
}
